// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info_wrapper__5O6qd {
  width: 100%;
  height: calc(100vh - 110px); }
  .info_wrapper__5O6qd .info_main__fk-8y {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    overflow: auto;
    padding: 30px 5px 0 5px; }

.info_tabs__nV5bJ {
  position: relative;
  display: flex;
  gap: 20px; }

.info_tab__CqyYy {
  padding: 15px 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  text-decoration: none;
  transition: all 0.4s; }
  .info_tab__CqyYy span {
    transition: all 0.4s; }

.info_active__xhVWN {
  color: #fe6100;
  border-bottom: 3px solid #FE6100; }

.info_noActive__T-CPf {
  color: #212121;
  border-bottom: 3px solid #FFFFFF; }
  .info_noActive__T-CPf:active span {
    color: #b62f00; }
  .info_noActive__T-CPf:hover {
    background: rgba(254, 97, 0, 0.1);
    border-bottom: 3px solid rgba(254, 97, 0, 0.1); }
    .info_noActive__T-CPf:hover span {
      color: #fe6100; }
`, "",{"version":3,"sources":["webpack://./src/pages/info/info.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B,EAAA;EAF7B;IAII,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,uBAAuB,EAAA;;AAG3B;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS,EAAA;;AAGX;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oBAAoB,EAAA;EAPtB;IASI,oBAAoB,EAAA;;AAGxB;EACE,cAAc;EACd,gCAAgC,EAAA;;AAElC;EACE,cAAc;EACd,gCAAgC,EAAA;EAFlC;IAKM,cAAc,EAAA;EALpB;IASI,iCAAiC;IACjC,8CAA8C,EAAA;IAVlD;MAYM,cAAc,EAAA","sourcesContent":[".wrapper {\n  width: 100%;\n  height: calc(100vh - 110px);\n  .main {\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    overflow: auto;\n    padding: 30px 5px 0 5px;\n  }\n}\n.tabs {\n  position: relative;\n  display: flex;\n  gap: 20px;\n}\n\n.tab {\n  padding: 15px 8px;\n  cursor: pointer;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  text-decoration: none;\n  transition: all 0.4s;\n  span{\n    transition: all 0.4s;\n  }\n}\n.active {\n  color: #fe6100;\n  border-bottom: 3px solid #FE6100;\n}\n.noActive {\n  color: #212121;\n  border-bottom: 3px solid #FFFFFF;\n  &:active {\n    span {\n      color: #b62f00;\n    }\n  }\n  &:hover {\n    background: rgba(254, 97, 0, 0.1);\n    border-bottom: 3px solid rgba(254, 97, 0, 0.1);\n    span {\n      color: #fe6100;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `info_wrapper__5O6qd`,
	"main": `info_main__fk-8y`,
	"tabs": `info_tabs__nV5bJ`,
	"tab": `info_tab__CqyYy`,
	"active": `info_active__xhVWN`,
	"noActive": `info_noActive__T-CPf`
};
export default ___CSS_LOADER_EXPORT___;
